import { recipientAppConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveRecipientApp = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressApp.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':appId', form.id) :
            url.recipientProgressApps.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: recipientAppConstants.SAVING_RECIPIENT_APP_REQUEST }),
        success: (data) => ({ type: recipientAppConstants.SAVING_RECIPIENT_APP_SUCCESS, data }),
        failure: (error) => ({ type: recipientAppConstants.SAVING_RECIPIENT_APP_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved application.' }
        }
    }
});

export const deleteRecipientApp = ({ recipientId, progressId, appId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressApp.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':appId', appId),
        method: 'DELETE',
        request: () => ({ type: recipientAppConstants.DELETE_RECIPIENT_APP_REQUEST }),
        success: (data) => ({ type: recipientAppConstants.DELETE_RECIPIENT_APP_SUCCESS, data }),
        failure: (error) => ({ type: recipientAppConstants.DELETE_RECIPIENT_APP_FAILURE, error }),
        formatData: () => (appId),
        progress: {
            request: { message: () => 'Deleting application' },
            success: { message: () => 'Deleted application.' }
        }
    }
});

export const loadRecipientApps = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressApps.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: recipientAppConstants.LOAD_RECIPIENT_APPS_REQUEST }),
        success: (data) => ({ type: recipientAppConstants.LOAD_RECIPIENT_APPS_SUCCESS, data }),
        failure: (error) => ({ type: recipientAppConstants.LOAD_RECIPIENT_APPS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/recipientApp.actions.js